import { useState, useContext } from 'react';

import { TestObjectiveAPI } from 'api/testObjectiveAPI';

import { OutlinedButton } from 'components/UIComponents';
import Modal from 'components/base/BaseModal';
import ListOfRecords from 'components/base/ListOfRecords';
import PageContainer from 'components/base/PageContainer/PageContainer';
import PageTitle from 'components/base/PageTitle/PageTitle';
import TestObjectiveForm from '../TestObjectiveForm';

import { ModalContext } from 'context/ModalContext';

import { IFilterParams } from 'interfaces/IFilterParams';
import { ITableColumn } from 'interfaces/ITableColumn';
import { ITestObjective } from 'interfaces/TestObjective/ITestObjective';

import { columns } from '../columns';

const TEST_OBJECTIVE_FORM_MODAL_NAME = 'testObjectiveFormModal';

const ListOfTestObjectives = () => {
  const { onModalOpen, onModalClose } = useContext(ModalContext);
  const [editObjectiveId, setEditObjectiveId] = useState(0);
  const [editValues, setEditValues] = useState({ briefDescription: '', longDescription: '' });
  const [dataProvider, setDataProvider] = useState(
    () => (params: IFilterParams) => TestObjectiveAPI.getAll(params)
  );

  const reloadList = () => {
    setDataProvider(() => (params: IFilterParams) => TestObjectiveAPI.getAll(params));
  };

  const onEditClick = (id: number, item?: any) => {
    setEditObjectiveId(id);
    if (item) {
      setEditValues({
        briefDescription: item.brief_description || '',
        longDescription: item.long_description || '',
      });
    }
    onModalOpen(TEST_OBJECTIVE_FORM_MODAL_NAME);
  };

  const onAddNewClick = () => {
    setEditObjectiveId(0);
    setEditValues({ briefDescription: '', longDescription: '' });
    onModalOpen(TEST_OBJECTIVE_FORM_MODAL_NAME);
  };

  const dataFormatter = (item: ITestObjective) => ({
    id: item.id,
    product_name: item.product_name,
    year: item.year,
    number: item.number,
    brief_description: item.brief_description,
    long_description: item.long_description,
  });

  return (
    <PageContainer>
      <PageTitle>Test Objectives</PageTitle>
      <ListOfRecords
        tableProps={{
          name: 'test_objectives',
          columns: columns as ITableColumn[],
          editAction: onEditClick,
        }}
        barActions={<OutlinedButton onClick={onAddNewClick}>Add Objective</OutlinedButton>}
        dataFormatter={dataFormatter}
        dataProvider={dataProvider}
      />
      <Modal
        name={TEST_OBJECTIVE_FORM_MODAL_NAME}
        title={editObjectiveId ? 'Edit Objective' : 'Add Objective'}
        onModalClose={onModalClose}
      >
        <TestObjectiveForm
          onModalClose={() => onModalClose(TEST_OBJECTIVE_FORM_MODAL_NAME)}
          successAction={reloadList}
          editObjectiveId={editObjectiveId}
          editValues={editValues}
        />
      </Modal>
    </PageContainer>
  );
};

export default ListOfTestObjectives;
